export const LOGIN_TEXT_KEYS = ['BUTTON_CUSTOMER_SUPPORT', 'MOBILE_LOGIN_LOGIN_BUTTON', 'FORGOT_PASSWORD'];

export const LOGIN_FORM_TEXT_KEYS = [
	'MOBILE_LOGIN_AJAX_FAILURE',
	'MOBILE_LOGIN_USERNAME_EMAIL_PLACEHOLDER',
	'MOBILE_LOGIN_PASSWORD_PLACEHOLDER',
	'MOBILE_LOGIN_LOGIN_BUTTON',
	'MOBILE_LOGIN_FORGOT_PASSWORD'
];

export const LOGIN_SIDEBAR_TEXT_KEYS = ['MOBILE_LOGIN_LOGIN_BUTTON', 'DONT_YOU_HAVE_AN_ACCOUNT_JOIN_US'];

export const LOGIN_TABS_TEXT_KEYS = [
	'LOGIN_TAB_BANKID_LOGIN',
	'LOGIN_TAB_CLASSIC_LOGIN',
	'LOGIN_TAB_PAG_LOGIN',
	'LOGIN_TAB_DANISH_LOGIN',
	'LOGIN_TAB_PHONE_LOGIN'
];

export const PAG_LOGIN_FORM_TEXT_KEYS = [
	'MOBILE_PAG_LOGIN_TAB_MAIN_TITLE',
	'MOBILE_PAG_LOGIN_TAB_SUPPORT_TITLE',
	'MOBILE_PAG_LOGIN_TAB_BTN_PLAY',
	'MOBILE_PAG_LOGIN_TAB_BTN_BALANCE',
	'MOBILE_PAG_LEARN_MORE'
];

export const MODAL_POPUP_TEXT_KEYS = [
	'MOBILE_ROFUS_EXCLUDED_TEMPORARILY_ON_ROFUS_TEXT',
	'ACCOUNT_CLOSED_HEADER',
	'OPEN_SUPPORT_BUTTON',
	'CLOSE_BUTTON',
	'BUTTON_ACCOUNT_REOPEN_NOW',
	'BUTTON_CANCEL',
	'MOBILE_TRUSTLY_LOGIN_RESULT',
	'BUTTON_CUSTOMER_SUPPORT',
	'COOLOFF_PERIOD',
	'BUTTON_FORGOT_PASSWORD',
	'ACCOUNT_INFORMATION',
	'BUTTON_OK',
	'LOG_OUT',
	'TRYAGAIN',
	'LUGAS_ERROR_HEADER',
	'CREATE_ACCOUNT',
	'MOBILE_LOGIN_AJAX_FAILURE',
	'BANKID_BL_COULD_NOT_SET_LIMITS',
	'SYSTEM_ERROR_GENERAL',
	'BACK',
	'ACCOUNT_CLOSED_REOPEN_NOW_MESSAGE',
	'ACCOUNT_CLOSED_CONTACT_SUPPORT_MESSAGE',
	'PASSWORD_REMINDER_ERROR_HEADER',
	'PASSWORD_REMINDER',
	'VERIFY_POPUP_LUGAS_HEADER',
	'VERIFY_POPUP_LUGAS_OCCUPATED_MESSAGE',
	'VERIFY_POPUP_LUGAS_NOT_TIME_MESSAGE',
	'VERIFY_POPUP_LUGAS_GENERAL_MESSAGE',
	'ACCOUNT_SCHUFA_UNVERIFIED_HEADER',
	'ACCOUNT_SCHUFA_UNVERIFIED_SUPPORT_MESSAGE',
	'LUGAS_GENERAL_ERROR_HEADER',
	'LUGAS_GENERAL_ERROR_MESSAGE',
	'LUGAS_FIELD_VALIDATION_FAILED_HEADER',
	'LUGAS_FIELD_VALIDATION_FAILED_MESSAGE',
	'EMAIL_REQUIRED_HEADER',
	'EMAIL_REQUIRED_MESSAGE',
	'PLAYER_NOT_REGISTERED_HEADER',
	'PLAYER_NOT_REGISTERED_MESSAGE',
	'LOGIN_PHONE_PLAYER_NOT_FOUND_HEADER',
	'LOGIN_PHONE_PLAYER_NOT_FOUND_MESSAGE',
	'MOBILE_TRUSTLY_LOGIN_FAILED_TITLE',
	'MOBILE_TRUSTLY_LOGIN_FAILED_TEXT',
	'MOBILE_TRUSTLY_VERIFED_EMAIL_TITLE',
	'MOBILE_TRUSTLY_VERIFED_EMAIL_TEXT',
	'RG_LIMITS_EXIST_FOR_REGULAR_TITLE',
	'RG_LIMITS_EXIST_FOR_REGULAR_TEXT',
	'RG_DUPLICATE_PLAYER_TITLE',
	'RG_DUPLICATE_PLAYER_TEXT',
	'RG_REGULAR_ACCOUNT_CLOSED_TITLE',
	'RG_REGULAR_ACCOUNT_CLOSED_TEXT',
	'BLACKLISTED_TITLE',
	'BLACKLISTED_TEXT',
	'SPELPAUS_EXCLUDED_ON_REGISTRATION_TITLE',
	'SPELPAUS_EXCLUDED_ON_REGISTRATION_TEXT',
	'SPELPAUS_EXCLUDED_ON_LOGIN_TITLE',
	'SPELPAUS_EXCLUDED_ON_LOGIN_TEXT',
	'REGISTRATION_BLOCKED_REGION_TITLE',
	'REGISTRATION_BLOCKED_REGION_TEXT',
	'SCHUFA_VALIDATION_ERROR_TITLE',
	'SCHUFA_VALIDATION_ERROR_TEXT',
	'OASIS_EXCLUDED_ON_LOGIN_TEXT',
	'OASIS_EXCLUDED_ON_LOGIN_TITLE',
	'OASIS_EXCLUDED_ON_REGISTRATION_TEXT',
	'OASIS_EXCLUDED_ON_REGISTRATION_TITLE',
	'SPELPAUS_COMMUNICATION_ERROR_TEXT',
	'SPELPAUS_COMMUNICATION_ERROR_TITLE',
	'FORGOT_PASSWORD',
	'ACCOUNT_IS_LOCKED_TOO_MANY_LOGIN_ATTEMPTS_HEADER',
	'PLAYER_EMAIL_NOT_FOUND_HEADER',
	'SGA_PLAYER_HIDDEN_DATA_TEXT',
	'SGA_PLAYER_HIDDEN_DATA_TITLE'
];
